export const initialState = {
    isFetching: false,
    data: undefined
};

export const urls = {
    consumePackage: '/api/monetization/consumption/consume'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_PACKAGE_CONSUMPTION':
            return {
                data: action.data
            };

        case 'REQUEST_PACKAGE_CONSUMPTION':
            return {
                data: action.data
            };

        default:
            return state;
    }
};
